import { api } from "./api";

/**
 * One row of GET /approvals/pending — the server's pendingApprovalRow (approval.go),
 * already filtered to what the caller may act on. `documentType` is kept as a plain
 * string because the endpoint returns every approvable type, not just the subset the
 * generated ApprovalInstance union names.
 */
export interface PendingApproval {
  instance: { documentType: string; documentId: number; currentStepOrder: number };
  docNo: string;
  amountLaari?: number;
}

export async function fetchPendingApprovals(): Promise<PendingApproval[]> {
  const res = await api.get<PendingApproval[]>("/approvals/pending");
  return res.data;
}
